import "@fontsource/oxygen";
import "@fontsource/oxygen/700.css";

import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import "./i18n";
import { AuthProviderComponent } from "./providers/auth-provider";
import { BrowserRouter } from "react-router-dom";
import { ResourceRootProvider } from "./layouts/ResourceContext";
import { init } from "./init";

init();

ReactDOM.createRoot(document.getElementById("root")!).render(
  <AuthProviderComponent>
    <BrowserRouter>
      <ResourceRootProvider>
        <App />
      </ResourceRootProvider>
    </BrowserRouter>
  </AuthProviderComponent>,
);
